import { withInstall } from '../../../../utils/with-install'
import Vector from './Vector.vue'

export const ElAmapLayerVector = withInstall(Vector)
export default ElAmapLayerVector
